import { Container } from '@mui/material'

import { ImageBox } from '@/components/Banner/Banner.styled'
import { ImageBanner } from '@/components/Banner/ImageBanner'
import { LocaleText } from '@/components/LocaleText'

import type React from 'react'
import type { UnpackedTextColumnImagesBanner } from '@/lib/queries/sanityQueryStrings'

export const TextColumnImagesBanner: React.FC<{
  sanityComponent: UnpackedTextColumnImagesBanner
}> = ({ sanityComponent }) => {
  const columnImages = sanityComponent?.columnImages ?? []

  return (
    <Container disableGutters>
      <LocaleText {...sanityComponent.title} _type="localeText" typographyProps={{ variant: 'banner2' }} />

      {columnImages.length > 0 && (
        <ImageBox>
          {columnImages.map((textColumnImage, idx) => (
            <ImageBanner textColumnImage={textColumnImage} key={idx} />
          ))}
        </ImageBox>
      )}
    </Container>
  )
}
